import * as stylex from "@stylexjs/stylex";
const spin = "x1fy8ia8-B";
export function Spinner({
  size = 14,
  label = "Loading"
}: {
  size?: number;
  label?: string;
}) {
  return <output aria-label={label} {...stylex.props(styles.spinner, styles.size(size))} />;
}
const styles = {
  spinner: {
    k1xSpc: "x1rg5ohu",
    kmuXW: "x2lah0s",
    kaIpWk: "x16rqkct",
    kMzoRj: "xvndefy",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1r7ld26",
    k26BEO: "xhe5wa1",
    kSiTet: "x1ks1olk",
    kKVMdj: "xpedhrg",
    k44tkh: "xof6966",
    kyAemX: "x1esw782",
    ko0y90: "xa4qsjk",
    $$css: true
  },
  size: (size: number) => [{
    kzqmXN: size != null ? "x5lhr3w" : size,
    kZKoxP: size != null ? "x16ye13r" : size,
    $$css: true
  }, {
    "--x-width": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(size),
    "--x-height": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(size)
  }]
};